/* Кнопки и переключатели */

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--mnk-space-2);
  border: 1px solid transparent;
  border-radius: var(--mnk-radius-md);
  padding: 0 var(--mnk-space-4);
  height: 40px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background var(--mnk-duration-fast) var(--mnk-ease),
    border-color var(--mnk-duration-fast) var(--mnk-ease),
    transform var(--mnk-duration-fast) var(--mnk-ease);
}

.button:active:not(:disabled) {
  transform: translateY(1px);
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.primary {
  background: var(--mnk-accent);
  color: var(--mnk-accent-contrast);
  box-shadow: var(--mnk-shadow-sm);
}

.primary:hover:not(:disabled) {
  background: var(--mnk-accent-hover);
}

.secondary {
  background: var(--mnk-surface);
  color: var(--mnk-text);
  border-color: var(--mnk-border);
}

.secondary:hover:not(:disabled) {
  background: var(--mnk-surface-hover);
  border-color: var(--mnk-border-strong);
}

.ghost {
  background: transparent;
  color: var(--mnk-text-muted);
}

.ghost:hover:not(:disabled) {
  background: var(--mnk-surface);
  color: var(--mnk-text);
}

.danger {
  background: var(--mnk-danger);
  color: #fff;
}

.danger:hover:not(:disabled) {
  filter: brightness(1.1);
}

.sizeSm {
  height: 32px;
  padding: 0 var(--mnk-space-3);
  font-size: var(--mnk-text-sm);
}

.sizeLg {
  height: 48px;
  padding: 0 var(--mnk-space-5);
  font-size: var(--mnk-text-lg);
}

.block {
  width: 100%;
}

.iconButton {
  width: 40px;
  height: 40px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--mnk-radius-md);
  border: 1px solid var(--mnk-border);
  background: var(--mnk-surface);
  color: var(--mnk-text-muted);
  cursor: pointer;
  transition: all var(--mnk-duration-fast) var(--mnk-ease);
}

.iconButton:hover:not(:disabled) {
  color: var(--mnk-text);
  border-color: var(--mnk-border-strong);
}

.iconButton:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.iconSm {
  width: 32px;
  height: 32px;
}

/* ---------- Переключатель ---------- */

.switch {
  display: inline-flex;
  align-items: center;
  gap: var(--mnk-space-3);
  cursor: pointer;
  user-select: none;
}

.switchInput {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.switchTrack {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: var(--mnk-radius-pill);
  background: var(--mnk-border);
  transition: background var(--mnk-duration-base) var(--mnk-ease);
  flex: none;
}

.switchThumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--mnk-text);
  transition: transform var(--mnk-duration-base) var(--mnk-ease);
}

.switchInput:checked + .switchTrack {
  background: var(--mnk-accent);
}

.switchInput:checked + .switchTrack .switchThumb {
  transform: translateX(20px);
  background: var(--mnk-accent-contrast);
}

.switchInput:focus-visible + .switchTrack {
  box-shadow: var(--mnk-focus-ring);
}

.switchInput:disabled + .switchTrack {
  opacity: 0.5;
}

/* ---------- Флажок и радиокнопка ---------- */

.check {
  display: inline-flex;
  align-items: center;
  gap: var(--mnk-space-2);
  cursor: pointer;
}

.checkBox {
  appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid var(--mnk-border-strong);
  border-radius: var(--mnk-radius-sm);
  background: var(--mnk-bg-sunken);
  display: grid;
  place-content: center;
  cursor: pointer;
  flex: none;
}

.checkBox[type="radio"] {
  border-radius: 50%;
}

.checkBox:checked {
  background: var(--mnk-accent);
  border-color: var(--mnk-accent);
}

.checkBox:checked::after {
  content: "";
  width: 10px;
  height: 6px;
  border-left: 2px solid var(--mnk-accent-contrast);
  border-bottom: 2px solid var(--mnk-accent-contrast);
  transform: rotate(-45deg) translate(1px, -1px);
}

.checkBox[type="radio"]:checked::after {
  width: 8px;
  height: 8px;
  border: 0;
  border-radius: 50%;
  background: var(--mnk-accent-contrast);
  transform: none;
}

.checkBox:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ---------- Ползунок ---------- */

.slider {
  display: flex;
  align-items: center;
  gap: var(--mnk-space-3);
  width: 100%;
}

.sliderInput {
  appearance: none;
  flex: 1;
  height: 4px;
  border-radius: var(--mnk-radius-pill);
  background: var(--mnk-border);
  cursor: pointer;
}

.sliderInput::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--mnk-accent);
  border: 2px solid var(--mnk-bg);
  cursor: pointer;
}

.sliderInput::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border: 2px solid var(--mnk-bg);
  border-radius: 50%;
  background: var(--mnk-accent);
  cursor: pointer;
}

.sliderValue {
  min-width: 48px;
  text-align: right;
  font-family: var(--mnk-font-mono);
  color: var(--mnk-text-muted);
  font-size: var(--mnk-text-sm);
}

/* ---------- Группа кнопок ---------- */

.group {
  display: inline-flex;
  background: var(--mnk-bg-sunken);
  border: 1px solid var(--mnk-border);
  border-radius: var(--mnk-radius-md);
  padding: 3px;
  gap: 3px;
}

.groupItem {
  border: 0;
  background: transparent;
  color: var(--mnk-text-muted);
  padding: 6px var(--mnk-space-3);
  border-radius: calc(var(--mnk-radius-md) - 3px);
  cursor: pointer;
  font-size: var(--mnk-text-sm);
  font-weight: 600;
}

.groupItemActive {
  background: var(--mnk-surface);
  color: var(--mnk-text);
  box-shadow: var(--mnk-shadow-sm);
}
